'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _RadioGroupComponent = require('../../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _application = require('../../transformers/rimisecureadvantageplus/application');

var _application2 = _interopRequireDefault(_application);

var _Quote = require('../../validators/rimisecureadvantageplus/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../language/translate');

var _InitialValues = require('../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _commonFunctions = require('../../helpers/commonFunctions');

var _quote = require('../../transformers/rimisecureadvantageplus/quote');

var _quote2 = _interopRequireDefault(_quote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fields = [].concat(_toConsumableArray((0, _commonFunctions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantDetailFields)()), ['application.additional_data.policy_type', 'application.additional_data.tracking_code', 'application.additional_data.billing_date', 'applicant[].additional_data.mq.mq1', 'applicant[].additional_data.mq.mq2', 'applicant[].additional_data.mq.mq3', 'applicant[].additional_data.mq.mq4', 'applicant[].additional_data.mq.mq5', 'applicant[].additional_data.mq.mq6', 'applicant[].additional_data.mq.mq7', 'applicant[].additional_data.mq.mq8']);

var medicalQuestions = [{ key: 'mq1', text: 'Cancer, Intracranial Tumour' }, { key: 'mq2', text: 'Heart Disease (including but not limited to Angina and Heart Attack)' }, { key: 'mq3', text: 'Stroke, Transient Ischemic Attack (TIA), Peripheral Vascular Disease or Diabetes' }, { key: 'mq4', text: 'Hepatitis, including Hepatitis Carrier State, Chronic Kidney Disease, AIDS or HIV' }, { key: 'mq5', text: 'Have you ever had Coronary Artery Bypass surgery and/or Aortic surgery?' }, { key: 'mq6', text: 'Have you undergone any medical or diagnostic tests for which you currently await results or have been advised by a doctor or a specialist to undergo any medical or diagnostic tests which have not yet been completed?' }, { key: 'mq7', text: 'Within the past 5 years, have you had any signs and/or symptoms of, received treatment for, or have been advised to seek treatment regarding Drug Abuse and/or Alcoholism?' }, { key: 'mq8', text: 'Are you a smoker?' }];

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.onChangeHook = _this.onChangeHook.bind(_this);

    _this.recurringPaymentsAllowed = _this.recurringPaymentsAllowed.bind(_this);
    _this.getCoverageOptions = _this.getCoverageOptions.bind(_this);
    _this.disableExpiryDate = _this.disableExpiryDate.bind(_this);
    _this.getExpiryDate = _this.getExpiryDate.bind(_this);
    _this.disabledExpiryDate = true;
    _this.hasDefaultExpiry = true;

    _this.ageLimits = {
      maxYears: 69,
      maxEffDays: 31,
      minYears: 18
    };

    _this.applicantOptions = {
      headerLabel: 'Applicant',
      sectionHeaderLabel: 'Application Information'
    };

    _this.state = {
      showNames: true,
      formFilled: false,
      showSaveQuote: true,
      showErrors: false,
      showMQModal: false
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      if (this.props.fields.application.additional_data.additional_applicants_number.value === '') {
        this.props.fields.application.additional_data.additional_applicants_number.onChange(_InitialValues2.default.additional_applicants_number);
      }
      if (this.props.fields.applicant.length === 0) {
        this.props.fields.applicant.addField();
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      (0, _commonFunctions.updateQuote)(this, _application2.default);
    }
  }, {
    key: 'getCoverageOptions',
    value: function getCoverageOptions(defaultCoverageOptions) {
      return defaultCoverageOptions;
    }
  }, {
    key: 'getDefaultExpiryDate',
    value: function getDefaultExpiryDate() {
      var effDate = this.props.fields.application.effective_date.value;
      return effDate ? (0, _moment2.default)(effDate).add(364 + _dateFunctions2.default.getLeapYearDay(effDate, 364), 'days') : null;
    }
  }, {
    key: 'getExpiryDate',
    value: function getExpiryDate() {
      return this.getDefaultExpiryDate();
    }
  }, {
    key: 'disableExpiryDate',
    value: function disableExpiryDate() {
      return true;
    }
  }, {
    key: 'recurringPaymentsAllowed',
    value: function recurringPaymentsAllowed() {
      return true;
    }
  }, {
    key: 'allMqsAnsweredAndAnyOneYes',
    value: function allMqsAnsweredAndAnyOneYes() {
      if (!this.props.fields.applicant.length) return false;
      var anyOneYes = false;
      var mqResponses = this.props.fields.applicant[0].additional_data.mq;

      for (var i = 0; i < medicalQuestions.length - 1; i++) {
        if (mqResponses[medicalQuestions[i].key].value === 'Yes') {
          anyOneYes = true;
          break;
        }
      }

      return anyOneYes && _react2.default.createElement(
        'p',
        { className: 'text-danger center' },
        (0, _translate.t)('The applicant is not eligible for the RIMI Secure Advantage Plus Product')
      );
    }
  }, {
    key: 'showMQModal',
    value: function showMQModal() {
      this.setState({ showMQModal: true });
    }
  }, {
    key: 'hideMQModal',
    value: function hideMQModal() {
      this.setState({ showMQModal: false });
      this.onChangeHook();
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      (0, _quote2.default)(this);
      var dateRestrictions = _dateFunctions2.default.getDateLimits(this.props.values, this.ageLimits);

      return _react2.default.createElement(
        _reactBootstrap.Form,
        {
          horizontal: true, onSubmit: this.props.handleSubmit
        },
        (0, _commonFunctions.showErrorDiv)(this),
        (0, _commonFunctions.showPrimaryApplicantInfo)(this, dateRestrictions, this.applicantOptions, true),
        (0, _commonFunctions.showEligibilityBox)(this, true),
        this.props.hasPolicyType ? (0, _commonFunctions.policyTypeField)(this) : null,
        (0, _commonFunctions.effectiveDateField)(this, dateRestrictions),
        (0, _commonFunctions.expiryDateField)(this, dateRestrictions),
        (0, _commonFunctions.showSectionHeader)(this.formConfig.health_questionnaire_header.title),
        _react2.default.createElement(
          'div',
          { className: 'margin-topbottom-20' },
          (0, _translate.t)('Have you ever been diagnosed with, had any signs and/or symptoms of, or had any medical consultations and/or abnormal tests for any of the following disorders?')
        ),
        this.props.fields.applicant.length && medicalQuestions.map(function (question, index) {
          return _react2.default.createElement(
            'div',
            { className: 'row', key: question.key },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              _react2.default.createElement(_LabelledInputComponent2.default, {
                inputId: question.key,
                inputLabel: index + 1 + '. ' + (0, _translate.t)(question.text),
                inputComponent: _RadioGroupComponent2.default,
                inputComponentField: _this2.props.fields.applicant[0].additional_data.mq[question.key],
                inputComponentProps: {
                  onChangeHook: _this2.onChangeHook,
                  options: [{ value: 'Yes', text: 'Yes' }, { value: 'No', text: 'No' }]
                },
                mqRadio: 1
              })
            )
          );
        }),
        this.allMqsAnsweredAndAnyOneYes(),
        _react2.default.createElement(
          'div',
          { className: 'margin-top-30' },
          (0, _commonFunctions.showSaveQuoteComponent)(this, _application2.default)
        )
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  savedQuote: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/rimi-secure-advantage-plus/GetQuoteContainer.jsx
// module id = 1700
// module chunks = 0